var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 16.6249C9.5 16.1877 9.85443 15.8333 10.2917 15.8333H16.625C17.0622 15.8333 17.4167 16.1877 17.4167 16.6249C17.4167 17.0622 17.0622 17.4166 16.625 17.4166H10.2917C9.85443 17.4166 9.5 17.0622 9.5 16.6249Z",
    fill: "#094A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4458 6.41237C17.7202 5.13293 17.6661 3.45279 16.7145 2.42387C16.2504 1.92216 15.59 1.6017 14.8419 1.58403C14.0911 1.56629 13.3132 1.85342 12.5954 2.45396C12.5771 2.46932 12.5594 2.4855 12.5425 2.50246L2.27562 12.8103C1.83227 13.2554 1.58334 13.8581 1.58334 14.4864V15.8271C1.58334 16.6991 2.28949 17.4166 3.16971 17.4166H4.49877C5.1303 17.4166 5.73583 17.1651 6.18149 16.7176L16.4458 6.41237ZM13.6223 4.586C13.3132 4.27684 12.8119 4.27684 12.5027 4.586C12.1936 4.89517 12.1936 5.39642 12.5027 5.70559L13.2944 6.49726C13.6035 6.80642 14.1048 6.80642 14.414 6.49726C14.7231 6.18809 14.7231 5.68684 14.414 5.37767L13.6223 4.586Z",
    fill: "#094A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit1.9231b2664e31ee93789b9734caf4eb5d.svg";
export { ForwardRef as ReactComponent };